import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Permission } from '../../enums/permission.enum';

export type SubNavContext = {
	actions?: SubNavActions;
	tipsAndTricks?: TipsAndTricksSummary;
	TipAndTrickPageType?: TipAndTrickPageTypeEnum;
	analyze?: SubNavActions;
	reports?: SubNavActions;
	report?: ReportSummary;
	reportSnapshot?: ReportSnapshotItem;
};

export type SubNavActions = {
	title: string;
	actionsList?: SubNavAction[];
};

export type SubNavAction = {
	url: string;
	title: string;
	icon: IconProp;
	permission?: Permission;
	tooltip?: string;
	prevUrlRefObject?: string;
	type?: 'create' | 'view';
	order?: number;
};

export type TipsAndTricksSummary = {
	TipsAndTricksContent: TipsAndTricksContent;
};

export type TipsAndTricksContent = {
	help_title: string;
	help_description: string;
	help_url: string;
};

export enum TipAndTrickType {
	VIDEO,
	PDF,
}

export enum TipAndTrickPageTypeEnum {
	DISCOVER = 1,
	ANALYZE = 2,
	REPORT = 3,
	PRESENT = 4,
}

export type AppThemeConfig = {
	window_title: string;
	header_background_color: string;
	menu_background_color: string;
	canvas_background_color: string;
	button_color: string;
	button_hover_color: string;
	logo_url: string;
};

export type ReportSummary = {
	title: string;
	reportList: ReportSummaryItem[];
};

export type ReportSummaryItem = {
	value: number;
	description: string;
};

export type ReportSnapshotItem = {
	title: string;
	chartId?: number;
	snapshotText: string;
	noFavToggled?: boolean;
};
